var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.348,
    height: 16.826,
    viewBox: "0 0 14.348 16.826",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-files",
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18902",
    "data-name": "Path 18902",
    d: "M18.219,5.341a.284.284,0,0,0-.015-.074c0-.01-.006-.02-.01-.03a.293.293,0,0,0-.058-.086h0L13.072.087a.29.29,0,0,0-.088-.058A.235.235,0,0,0,12.959.02.3.3,0,0,0,12.88,0a.184.184,0,0,0-.018,0H9.516A1.981,1.981,0,0,0,7.537,1.979v.5H6.154A1.981,1.981,0,0,0,4.175,4.455V14.547a1.981,1.981,0,0,0,1.979,1.979h6.728a1.981,1.981,0,0,0,1.979-1.979v-.5h1.384a1.981,1.981,0,0,0,1.979-1.979V5.361C18.223,5.354,18.219,5.348,18.219,5.341Zm-5.06-4.328L17.21,5.064H14.544a1.387,1.387,0,0,1-1.386-1.386V1.013Zm1.109,13.534a1.387,1.387,0,0,1-1.385,1.385H6.154a1.387,1.387,0,0,1-1.386-1.385V4.455A1.387,1.387,0,0,1,6.154,3.069H9.2V6.154a1.981,1.981,0,0,0,1.978,1.979h3.086v6.414Zm-.42-7.007H11.182A1.387,1.387,0,0,1,9.8,6.154V3.489Zm2.4,5.917H14.861V7.836c0-.007,0-.013,0-.02a.289.289,0,0,0-.015-.074c0-.01-.006-.02-.011-.03a.29.29,0,0,0-.058-.086h0L9.709,2.563A.3.3,0,0,0,9.622,2.5L9.6,2.5a.281.281,0,0,0-.078-.016.184.184,0,0,0-.018,0H8.13v-.5A1.387,1.387,0,0,1,9.516.593h3.049V3.679a1.981,1.981,0,0,0,1.979,1.979h3.085v6.413A1.386,1.386,0,0,1,16.244,13.457Z",
    transform: "translate(-4.175 0)",
    fill: "#7d7d7d",
    stroke: "#7d7d7d",
    strokeWidth: 0.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.06cdfe4a.svg";
export { ForwardRef as ReactComponent };